import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const initialize = function( section ){
  // const id = section.getAttribute('id');
  // const images = section.querySelectorAll('.image-collage__image');
  // images.forEach((image, index) => {
  //   gsap.to( image , { 
  //       transform: `translateX(${index % 2 === 0 ? 100 : -100}%) translateY(${index % 2 === 0 ? 100 : -100}%)`,
  //       scrollTrigger: {
  //       trigger: section,
  //       start: "top+=200px center",
  //       end: "bottom top+=500px",
  //       ease: "power1",
  //       scrub: true,
  //       pin: true
  //     }
  //   })
  // });
  //   ScrollTrigger.create({
//     trigger: id,
//     start: 'top top',
//     end: 'bottom 50%+=100px',
//     scrub: true,
//     pin: true,
//     anticipatePin: 1,
//     snap: 1 / (images.length - 1),
//     onToggle: (self) => console.log('toggled, isActive:', self.isActive),
//     onUpdate: (self) => {
//         console.log(
//             'progress:',
//             self.progress.toFixed(3),
//             'direction:',
//             self.direction,
//             'velocity',
//             self.getVelocity()
//         );
//     }
// });
}
const ImageCollage = function(){
  const sections = document.querySelectorAll('.image-collage');
  if (sections.length === 0) return;
  sections.forEach((section) => {
    initialize(section);
  });

}

export default ImageCollage